import React from "react";
import Layout from "layouts";
import CapacityComponent from "./CapacityComponent";

export default function Capacity() {
  return (
    <Layout breadCrumb={[{ label: "Capacity Control", to: "#" }]}>
      <CapacityComponent />
    </Layout>
  );
}
